// extracted by mini-css-extract-plugin
module.exports = {"global-event-listener-root":"global-event-listener-root-1Zff4tA"};